import { IFeedback } from "../../../../../model/feedback";

interface IFeedbackContent {
  title: string;
  feedbacks: Array<IFeedback>;
}

export const feedbackContent: IFeedbackContent = {
  title: "Veja o que nossos %associados% falam sobre nós:",
  feedbacks: [
    {
      title: "Ana Oliveira",
      subtitle: "Servidora Pública",
      comment:
        "O convênio da Afesp tem sido uma bênção para mim e minha família. Conseguimos atendimento de qualidade e ainda economizamos bastante com os descontos nas clínicas. Faz toda a diferença no orçamento!",
      rate: 5,
    },
    {
      title: "Rafael Almeida",
      subtitle: "Servidor Público",
      comment:
        "Depois que conheci o convênio Afesp, ficou muito mais fácil, porque eu consegui desconto em várias lojas na cidade.",
      rate: 5,
    },
    {
      title: "Ricardo Pereira",
      subtitle: "Servidor Público",
      comment:
        "O que mais gosto na Afesp é a variedade de clínicas conveniadas. Sempre encontro atendimento rápido e com desconto. É segurança e economia ao mesmo tempo.",
      rate: 5,
    },
    {
      title: "Melissa Rodrigues",
      subtitle: "Servidora Pública",
      comment:
        "A Afesp trouxe tranquilidade para minha vida. Saber que posso contar com opções de saúde e ainda pagar menos é algo que realmente vale a pena.",
      rate: 5,
    },
    {
      title: "Ana Silva",
      subtitle: "Servidora Pública",
      comment:
        "Recomendo o convênio Afesp para todos que querem cuidar da saúde sem pesar no bolso. Os descontos nas lojas e exames ajudam muito.",
      rate: 5,
    },
    {
      title: "João Oliveira",
      subtitle: "Servidor Público",
      comment:
        "O atendimento nas clínicas conveniadas pela Afesp é excelente. Além disso, os preços com desconto tornam tudo mais acessível.",
      rate: 5,
    },
    {
      title: "Gabriela Lima",
      subtitle: "Servidora Pública",
      comment:
        "Desde que comecei a usar o convênio Afesp, percebi como ficou mais simples agendar consultas e exames. É praticidade e economia no dia a dia.",
      rate: 5,
    },
    {
      title: "Maria Santos",
      subtitle: "Servidora Pública",
      comment:
        "A Afesp oferece opções de saúde que realmente funcionam. Já utilizei os descontos em clínica e fiquei muito satisfeito com o atendimento.",
      rate: 5,
    },
    {
      title: "Eduardo Souza",
      subtitle: "Servidor Público",
      comment:
        "Ter a Afesp como convênio é ter mais cuidado com a saúde e menos preocupação com os custos. É um benefício que faz diferença de verdade.",
      rate: 5,
    },
  ],
};